import React, { useContext } from 'react';
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from './comum/Context/auth.jsx';

/* Paginas */
import Site from './site/site.jsx';
import Login from './app/Login/index.jsx';
import Senha from './app/Login/novasenha.jsx';
import PrecoProduto from './app/Precos/index.jsx';
import Etiqueta from './app/Precos/etiqueta.jsx';
import PrecoImporta from './app/Precos/importapreco.jsx';
import Auditoria from './app/Precos/auditoria.jsx';
import Validade from './app/Precos/validade.jsx';
import Sap from './app/Sap';
import Home from "./app/Home";
import SapHorario from './app/SapHorario';
import Aeflor from './app/Aeflor';
import AeflorDepend from './app/AeflorDepend';
import AeflorInscricao from './app/AeflorInscricao';
import AeflorInscricaoManual from './app/AeflorInscricao/inscmanual.jsx';
import AeflorInscricaoconf from './app/AeflorInscricaoconf';
import ValidationOfData from './app/ValidationOfData';
import DadosFunc from './app/DadosFunc/index.jsx';
import Notificacoes from './app/DadosFunc/notificacao.jsx';
import Ponto from './app/Rhponto/index.jsx';
import Escala from './app/Rhponto/escala.jsx';
import RestauranteFun from './app/Restaurante/restaurante.jsx';
import HoleriteFun from './app/Holerite/holerite.jsx';
import AtestadoFun from './app/Atestado';
import ConvAeflor from './app/Aeflor/convenio.jsx';
import AssisAeflor from './app/Aeflor/assistencia.jsx';
import Ouvidoria from './app/Home/ouvidoria.jsx';
import CriarUsuario from './app/Usuario/CriarUsuario';
import ValidarUsuario from './app/Usuario/ValidarUsuario';
import AssociaLoja from './app/Usuario/asssociarloja.jsx';
import PontoOcorrencia from './app/Rhponto/pontoocorrencia.jsx';
import Rhcomunicado from './app/RhComunicado/index.jsx';
import Rhchamado from './app/RhChamado/index.jsx';
import Rhdashboard from './app/RhChamado/dashboard.jsx';
import RhCandidato from './app/RhCandidato/index.jsx';
import Rhacidente from './app/RhComunicado/acidente.jsx';
import ConciliacaoCartao from './app/FinCont/conciliacao.jsx';

import Equipamentos from './app/Operacao_Loja/equipamento.jsx';
import AdminEquipamento from './app/Operacao_Loja/equipamentoadmin.jsx';
import VistoriaModulo from './app/Operacao_Loja/vistoria.jsx';
import VistoriaResposta from './app/Operacao_Loja/respondervistoria.jsx';

/*Vendas*/
import FlashVendas from './app/Vendas/flash.jsx';
import MesVendas from './app/Vendas/vendames.jsx';
import MesVendasLoja from './app/Vendas/vendamesloja.jsx';
import VendaComparativo from './app/Vendas/vendacomparativo.jsx';
import VendasDeptoSecao from './app/Vendas/vendadepto.jsx';
import VendasCompDeptoSecao from './app/Vendas/vendadeptocomparativo.jsx';

/* R E S T A U R A N T E */
import HomeRest from "./restaurante/Home";
import DadosRest from "./restaurante/Dados";
import LoginRest from "./restaurante/Login/index.jsx";
import NovaConta from './restaurante/NovaConta/novaconta.jsx';
import ResetSenha from './restaurante/ResetSenha/resetsenha.jsx';
import AvaliacaoRest from './restaurante/Avaliacao';
import CardapioRest from './restaurante/Cardapio';

/* P A R C E R I A */
import LoginPar from "./parceria/Login/index.jsx";
import NovaContaPar from './parceria/NovaConta/novaconta.jsx';
import ResetSenhaPar from './parceria/ResetSenha/resetsenha.jsx';
import ParceriaCPF from './parceria/Busca/index.jsx';
import ParceriaLista from './parceria/BuscaLista/index.jsx';
import ParceriaVendas from './parceria/BuscaLista/vendas.jsx';
import ParceriaVendasDetalhes from './parceria/BuscaLista/vendasdetalhes.jsx';
import Cliente from './parceria/Clientes/index.jsx';

/* A T E N D I M E N T O */
import AtendimentoBusca from './atendimento/Busca';
import AtendimentoAtender from './atendimento/Atender';

import Pesquisa from './atendimento/Pesquisa';


//CheckList TI
import CadCheckListTI from './app/TICheckList/index.jsx';
import CheckList from './app/TICheckList/checklist.jsx';
import EsqueciSenha from './app/Login/novasenha.jsx';


//CHAMADO DEOS
import Chamados from './app/Chamado/chamado.jsx';
import AtendChamados from './app/Chamado/atendimento.jsx';
import DashChamados from './app/Chamado/dashboard.jsx';
import VendaDeptoSecao from './app/Vendas/vendadepto.jsx';



/* ---------------- SECURE ROUTE ---------------- */
function SecureRoute({ children }) {
  const { logado } = useContext(AuthContext);
  const location = useLocation();

  if (logado === null) {
    return (
      <div style={{ textAlign: "center", marginTop: "20%", color: "#666" }}>
        Verificando sessão...
      </div>
    );
  }

  if (!logado) {
    const redirectTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/arbor/login?redirect=${redirectTo}`} replace />;
  }

  return children;
}

/* ---------------- APP PRINCIPAL ---------------- */
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Site />} />
        <Route path='/arbor' element={<Login />} />
        <Route path='/arbor/login' element={<Login />} />
        <Route path='/arbor/verificacao/ValidationOfData/:tipo/:validacao' element={<ValidationOfData />} />
        <Route path='/trabalheconosco' element={<RhCandidato />} />
        <Route path='/pesquisa' element={<Pesquisa />} />
        <Route path='/arbor/esqueci-senha' element={<EsqueciSenha />} />

        <Route path='/arbor/atendimento/:loja' element={<AtendimentoBusca />} />              
        <Route path='/arbor/atendimento/fila' element={<AtendimentoAtender />} />    
        
        {/* Páginas protegidas */}
        <Route path='/arbor/home' element={<SecureRoute><Home /></SecureRoute>} />
        <Route path='/arbor/dadosfunc' element={<SecureRoute><DadosFunc /></SecureRoute>} />
        <Route path='/arbor/notificacoes' element={<SecureRoute><Notificacoes /></SecureRoute>} />
        <Route path='/arbor/restaurante' element={<SecureRoute><RestauranteFun /></SecureRoute>} />
        <Route path='/arbor/holerite' element={<SecureRoute><HoleriteFun /></SecureRoute>} />
        <Route path='/arbor/ouvidoria' element={<SecureRoute><Ouvidoria /></SecureRoute>} />
        <Route path='/arbor/ponto' element={<SecureRoute><Ponto /></SecureRoute>} />
        <Route path='/arbor/escala' element={<SecureRoute><Escala /></SecureRoute>} />
        <Route path='/arbor/ponto/ocorrencias' element={<SecureRoute><PontoOcorrencia /></SecureRoute>} />
        <Route path='/arbor/sap' element={<SecureRoute><Sap /></SecureRoute>} />
        <Route path='/arbor/sap/horario' element={<SecureRoute><SapHorario /></SecureRoute>} />
        <Route path='/arbor/aeflor' element={<SecureRoute><Aeflor /></SecureRoute>} />
        <Route path='/arbor/aeflor/convenio' element={<SecureRoute><ConvAeflor /></SecureRoute>} />
        <Route path='/arbor/aeflor/assistencia' element={<SecureRoute><AssisAeflor /></SecureRoute>} />
        <Route path='/arbor/aeflor/inscricao' element={<SecureRoute><AeflorInscricao /></SecureRoute>} />
        <Route path='/arbor/aeflor/inscricao/manual' element={<AeflorInscricaoManual />} />
        <Route path='/arbor/aeflor/ingresso' element={<SecureRoute><AeflorInscricaoconf /></SecureRoute>} />
        <Route path='/arbor/aeflor/dependente' element={<SecureRoute><AeflorDepend /></SecureRoute>} />
        <Route path='/arbor/atestado' element={<SecureRoute><AtestadoFun /></SecureRoute>} />
        <Route path='/arbor/usuario/consinco' element={<SecureRoute><AssociaLoja /></SecureRoute>} />
        <Route path='/arbor/comunicado' element={<SecureRoute><Rhcomunicado /></SecureRoute>} />
        <Route path='/arbor/rh/chamado' element={<SecureRoute><Rhchamado /></SecureRoute>} />
        <Route path='/arbor/rh/dashboard' element={<SecureRoute><Rhdashboard /></SecureRoute>} />
        <Route path='/arbor/rh/acidente' element={<SecureRoute><Rhacidente /></SecureRoute>} />
        <Route path='/arbor/fin/conciliacao' element={<SecureRoute><ConciliacaoCartao /></SecureRoute>} />

        {/*CHAMADOS*/}
         <Route path='/arbor/chamado' element={<SecureRoute><Chamados/></SecureRoute>} />
         <Route path='/arbor/chamado/atendimento' element={<SecureRoute><AtendChamados /></SecureRoute>} />
         <Route path='/arbor/chamado/dashboard' element={<DashChamados />} />
         

        <Route path='/arbor/equipamentos' element={<SecureRoute><Equipamentos /></SecureRoute>} />
        <Route path='/arbor/equipamentos/admin' element={<SecureRoute><AdminEquipamento /></SecureRoute>} />
        <Route path='/arbor/Loja/vistoria' element={<SecureRoute><VistoriaModulo /></SecureRoute>} />
        <Route path='/arbor/Loja/vistoria-execucao/:token' element={<SecureRoute><VistoriaResposta /></SecureRoute>} />
        

        {/* Outras rotas (não protegidas) */}
        <Route path='/preco/produto' element={<PrecoProduto />} />
        <Route path='/preco/Importa' element={<PrecoImporta />} />
        <Route path='/parceria/busca' element={<ParceriaCPF />} />
        <Route path='/parceria/lista/:codigo' element={<ParceriaLista />} />
        <Route path='/parceria/vendas/:codigo' element={<ParceriaVendas />} />
        <Route path='/parceria/vendasdetalhe/:codigo' element={<ParceriaVendasDetalhes />} />
        <Route path='/cliente' element={<Cliente />} />
                

        {/*VENDAS*/}
        <Route path='/arbor/vendas/flash' element={<SecureRoute><FlashVendas /> </SecureRoute>} />
        <Route path='/arbor/vendas/mes' element={<SecureRoute> <MesVendas /> </SecureRoute>} />
        <Route path='/arbor/vendas/loja' element={<SecureRoute> <MesVendasLoja /> </SecureRoute>} />
        <Route path='/arbor/vendas/comparativo' element={<SecureRoute> <VendaComparativo /> </SecureRoute>} />
        <Route path='/arbor/vendas/secao' element={<SecureRoute> <VendasDeptoSecao /> </SecureRoute>} />
        <Route path='/arbor/vendas/secao/compara' element={<SecureRoute> <VendasCompDeptoSecao /> </SecureRoute>} />


        {/*CheckList TI*/}
        <Route path='/arbor/checklist/cadastro' element={<SecureRoute><CadCheckListTI /></SecureRoute>} />
        <Route path='/arbor/checklist/checklist' element={<SecureRoute><CheckList /></SecureRoute>} />

        {/* Busca preço */}
        <Route path='/arbor/produto' element={<SecureRoute><Etiqueta /></SecureRoute>} />
        <Route path='/arbor/validade' element={<SecureRoute><Validade /></SecureRoute>} />
        <Route path='/arbor/produto/auditoria' element={<SecureRoute><Auditoria /></SecureRoute>} />

        {/* Restaurante */}
        <Route path='/restaurante/login' element={<LoginRest />} />
        <Route path='/restaurante/novaconta' element={<NovaConta />} />
        <Route path='/restaurante/resetsenha' element={<ResetSenha />} />
        <Route path='/restaurante/pedido' element={<SecureRoute><HomeRest /></SecureRoute>} />
        <Route path='/restaurante/dados' element={<SecureRoute><DadosRest /></SecureRoute>} />
        <Route path='/restaurante/avaliacao' element={<SecureRoute><AvaliacaoRest /></SecureRoute>} />
        <Route path='/restaurante/cardapio' element={<SecureRoute><CardapioRest /></SecureRoute>} />

        {/* Parceria */}
        <Route path='/parceria/login' element={<LoginPar />} />
        <Route path='/parceria/novaconta' element={<NovaContaPar />} />
        <Route path='/parceria/resetsenha' element={<ResetSenhaPar />} />

        {/* Novo usuário */}
        <Route path='/arbor/usuario/criar' element={<CriarUsuario />} />
        <Route path='/arbor/usuario/validar' element={<ValidarUsuario />} />

        {/* Padrão */}
        <Route path='*' element={<Site />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
